import { render, staticRenderFns } from "./RollObjectMenu.vue?vue&type=template&id=0a3d9bce&"
import script from "./RollObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./RollObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RollObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports